import { createTheme } from '@mui/material/styles';
import { presetPalettes } from '@ant-design/colors';
import ThemeOption from './theme';

export default function Palette(mode = 'light', presetColor) {
  const colors = presetPalettes;

  let greyPrimary, greyAscent, greyConstant;

  if (mode === 'dark') {
    greyPrimary = ['#121212','#1c1c1c','#222222','#2a2a2a','#3f3f3f','#6b7280','#9ca3af','#e5e7eb','#f3f4f6','#f9fafb','#ffffff'];
    greyAscent   = ['#1c1c1c','#2a2a2a','#e5e7eb','#f3f4f6'];
    greyConstant = ['#121212','#080808'];
  } else {
    greyPrimary  = ['#ffffff','#fafafa','#f5f5f5','#f0f0f0','#d9d9d9','#bfbfbf','#8c8c8c','#595959','#262626','#141414','#000000'];
    greyAscent   = ['#fafafa','#bfbfbf','#434343','#1f1f1f'];
    greyConstant = ['#fafafb','#e6ebf1'];
  }

  colors.grey = [...greyPrimary, ...greyAscent, ...greyConstant];

  const paletteColor = ThemeOption(colors, presetColor, mode);

  return createTheme({
    palette: {
      mode,
      common: { black: '#000', white: '#fff' },
      ...paletteColor,
      text: {
        primary:   mode === 'dark' ? '#e5e7eb' : paletteColor.grey[700],
        secondary: mode === 'dark' ? '#9ca3af' : paletteColor.grey[500],
        disabled:  mode === 'dark' ? '#3f3f3f' : paletteColor.grey[400]
      },
      action: {
        disabled: mode === 'dark' ? '#2a2a2a' : paletteColor.grey[300],
        hover:    mode === 'dark' ? 'rgba(229,231,235,0.05)' : 'rgba(0,0,0,0.04)',
        selected: mode === 'dark' ? 'rgba(229,231,235,0.08)' : 'rgba(0,0,0,0.08)'
      },
      divider: mode === 'dark' ? 'rgba(0,66,37,0.25)' : paletteColor.grey[200],
      background: {
        paper:   mode === 'dark' ? '#121212' : paletteColor.grey[0],
        default: mode === 'dark' ? '#080808' : paletteColor.grey.A50
      }
    }
  });
}
